import LegalPage, { LegalSection, LegalList } from "@/components/site/LegalPage";

export default function CookiePolicy() {
  return (
    <LegalPage
      title="Politica Cookie"
      eyebrow="Confidențialitate"
      subtitle="Informații despre cookie-urile utilizate pe site-ul AutoRIO și despre modul în care le poți gestiona."
      seoDesc="Politica de cookie-uri AutoRIO: tipuri de cookie-uri, scop, durată, drepturile utilizatorului."
      path="/politica-cookie"
    >
      <LegalSection title="Ce sunt cookie-urile?">
        <p>
          Cookie-urile sunt mici fișiere text pe care un site web le salvează în
          browserul tău atunci când îl vizitezi. Ele au rolul de a asigura
          funcționarea corectă a site-ului, de a reține preferințele tale și,
          uneori, de a analiza modul în care este utilizat site-ul, pentru a
          îmbunătăți experiența de navigare.
        </p>
        <p>
          Cookie-urile nu conțin viruși și nu pot rula programe pe dispozitivul
          tău. Nu colectăm date personale prin cookie-uri fără consimțământul
          tău explicit.
        </p>
      </LegalSection>

      <LegalSection title="Tipuri de cookie-uri utilizate">
        <p>
          Pe site-ul AutoRIO utilizăm două categorii principale de cookie-uri:
        </p>
        <LegalList
          items={[
            "Cookie-uri esențiale — necesare pentru funcționarea corectă a site-ului (memorarea sesiunii, preferințe de afișare, acceptare cookie-uri).",
            "Cookie-uri de analiză — ne ajută să înțelegem cum este utilizat site-ul (pagini vizitate, timp petrecut, sursă de trafic), fără a identifica persoane individuale.",
          ]}
        />
      </LegalSection>

      <LegalSection title="Cookie-uri esențiale">
        <p>
          Aceste cookie-uri sunt necesare pentru funcționarea de bază a
          site-ului și nu pot fi dezactivate. Fără ele, unele funcționalități
          nu vor mai fi disponibile:
        </p>
        <LegalList
          items={[
            "Reținerea faptului că ai închis banner-ul de cookie-uri.",
            "Menținerea sesiunii tale de utilizator (dacă ești logat în panoul administrativ).",
            "Reținerea preferințelor de vizualizare (splash screen etc.).",
          ]}
        />
      </LegalSection>

      <LegalSection title="Cookie-uri de analiză">
        <p>
          Aceste cookie-uri ne ajută să înțelegem, la nivel agregat și anonim,
          modul în care vizitatorii interacționează cu site-ul. Informațiile
          colectate sunt folosite exclusiv pentru a îmbunătăți conținutul și
          performanța site-ului.
        </p>
        <p>
          În cazul în care activăm în viitor instrumente terțe de analiză (ex:
          Google Analytics), această politică va fi actualizată corespunzător.
        </p>
      </LegalSection>

      <LegalSection title="Durata cookie-urilor">
        <p>
          Cookie-urile pot fi de sesiune (se șterg automat la închiderea
          browserului) sau persistente (rămân în browser o perioadă
          determinată, până la data expirării sau până sunt șterse manual).
        </p>
        <p>
          Preferința ta privind banner-ul de cookie-uri este reținută pe termen
          nedeterminat, până când ștergi datele browserului.
        </p>
      </LegalSection>

      <LegalSection title="Cum poți gestiona cookie-urile">
        <p>
          Ai control complet asupra cookie-urilor. Poți accepta, refuza sau
          șterge oricând cookie-urile prin setările browserului tău:
        </p>
        <LegalList
          items={[
            "Google Chrome: Setări → Confidențialitate și securitate → Cookie-uri",
            "Mozilla Firefox: Setări → Confidențialitate și securitate",
            "Safari: Preferințe → Confidențialitate",
            "Microsoft Edge: Setări → Cookie-uri și permisiuni site",
          ]}
        />
        <p>
          Te rugăm să ai în vedere că blocarea completă a cookie-urilor poate
          afecta funcționarea unor părți ale site-ului.
        </p>
      </LegalSection>

      <LegalSection title="Drepturile tale">
        <p>
          Conform legislației aplicabile (Regulamentul UE 2016/679 — GDPR și
          Legea 506/2004), ai următoarele drepturi:
        </p>
        <LegalList
          items={[
            "Dreptul de a fi informat cu privire la cookie-urile utilizate.",
            "Dreptul de a-ți exprima consimțământul pentru cookie-uri neesențiale.",
            "Dreptul de a-ți retrage consimțământul oricând.",
            "Dreptul de a solicita ștergerea datelor personale.",
          ]}
        />
      </LegalSection>

      <LegalSection title="Contact">
        <p>
          Pentru orice întrebare privind utilizarea cookie-urilor sau protecția
          datelor personale, ne poți contacta la datele afișate pe pagina{" "}
          <a
            href="/contact"
            className="text-[#D4AF37] font-semibold hover:underline"
          >
            Contact
          </a>
          .
        </p>
      </LegalSection>
    </LegalPage>
  );
}
